module.exports = "<div class=\"no-content\">Dashboard</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/pages/dashboard/dashboard.component.html
// module id = ../../../../../src/app/pages/dashboard/dashboard.component.html
// module chunks = 2